import { useState, useEffect, useCallback } from "react";
import { NavDropdown } from "react-bootstrap";
import api from "../utils/api";

/**
 * StorePicker — dropdown in the Navbar for selecting the active liquor store.
 * Stores are fetched from /api/stores and the selection is persisted in localStorage.
 */
function StorePicker() {
  const [stores, setStores] = useState([]);
  const [activeId, setActiveId] = useState(localStorage.getItem("activeStoreId") || "");

  const fetchStores = useCallback(async () => {
    try {
      const res = await api.get("/api/stores");
      if (res.data.success) {
        setStores(res.data.stores);
        // If no active store is set, default to first
        if (!activeId && res.data.stores.length > 0) {
          const firstId = res.data.stores[0]._id;
          setActiveId(firstId);
          localStorage.setItem("activeStoreId", firstId);
        }
      }
    } catch (err) {
      console.error("Failed to fetch stores:", err);
    }
  }, [activeId]);

  useEffect(() => {
    fetchStores();
  }, [fetchStores]);

  const handleSelect = (id) => {
    setActiveId(id);
    localStorage.setItem("activeStoreId", id);
    // Reload the page so all components re-fetch data for the new store
    window.location.reload();
  };

  const activeName = stores.find((s) => s._id === activeId)?.name || "Select Store";

  if (stores.length === 0) return null;

  return (
    <NavDropdown
      title={`🏪 ${activeName}`}
      id="store-picker-dropdown"
      menuVariant="dark"
    >
      {stores.map((store) => (
        <NavDropdown.Item
          key={store._id}
          active={store._id === activeId}
          onClick={() => handleSelect(store._id)}
        >
          {store.name}
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
}

export default StorePicker;
